import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import ContingencyHistory from "../../components/Hacienda/contingency/ContingencyHistory";

const ContingencyEventHistoryPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ContingencyHistory/>
    </DefaultLayout>
  );
};

export default ContingencyEventHistoryPage;
